import { helpers } from '@reveni-io/reveni-ui'

export const getCustomMessagesFormatted = (supportedLanguages = [], customMessages) => {
  const formattedMessages = {}

  for (const language of supportedLanguages || []) {
    const customMessage = customMessages?.[language]?.map(customMessage => ({
      ...customMessage,
      message: helpers.replaceNonBreakingSpaces(customMessage.message),
    }))

    formattedMessages[language] = customMessage
  }

  return formattedMessages
}

export const getTransformReturnPortalData = data => {
  const { store, sibling_portals, ...portalData } = data

  const transformedData = {
    ...store,
    ...portalData,
    returnPortalId: data?.id,
    storeId: store?.id,
    siblingReturnPortals: sibling_portals || [],
    merchant: store?.merchant,
    preferences: {
      ...portalData?.preferences,
      custom_messages: getCustomMessagesFormatted(store?.supported_languages, portalData?.preferences?.custom_messages),
    },
  }

  return transformedData
}
